module.exports = __webpack_public_path__ + "img/lp-mobile-phone-frame.ad35d63a.png";